export const FaceBookIcon = ({ circleFill, pathFill }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16" cy="16" r="16" fill={circleFill} />
      <path
        d="M17.3333 17.2H19.2381L20 14H17.3333V12.4C17.3333 11.576 17.3333 10.8 18.8571 10.8H20V8.112C19.7516 8.0776 18.8137 8 17.8232 8C15.7547 8 14.2857 9.3256 14.2857 11.76V14H12V17.2H14.2857V24H17.3333V17.2Z"
        fill={pathFill}
      />
    </svg>
  );
};

export const YouTubeIcon = ({ circleFill, pathFill }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16" cy="16" r="16" fill={circleFill} />
      <path
        d="M16.2037 9.33301C16.6487 9.33551 17.762 9.34634 18.9453 9.39384L19.3653 9.41217C20.5562 9.46801 21.7462 9.56467 22.337 9.72884C23.1245 9.95051 23.7428 10.5955 23.952 11.4138C24.2853 12.7138 24.327 15.2488 24.332 15.863L24.3328 15.9897V16.1347C24.327 16.7488 24.2853 19.2847 23.952 20.5838C23.7403 21.4047 23.1212 22.0505 22.337 22.2688C21.7462 22.433 20.5562 22.5297 19.3653 22.5855L18.9453 22.6047C17.762 22.6513 16.6487 22.663 16.2037 22.6647L16.0078 22.6655H15.7953C14.8537 22.6597 10.9153 22.6172 9.66199 22.2688C8.87533 22.0472 8.25616 21.4022 8.04699 20.5838C7.71366 19.2838 7.67199 16.7488 7.66699 16.1347V15.863C7.67199 15.2488 7.71366 12.713 8.04699 11.4138C8.25866 10.593 8.87783 9.94717 9.66283 9.72967C10.9153 9.38051 14.8545 9.33801 15.7962 9.33301H16.2037ZM14.3328 13.083V18.9163L19.3328 15.9997L14.3328 13.083Z"
        fill={pathFill}
      />
    </svg>
  );
};

export const TwitterIcon = ({ circleFill, pathFill }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16" cy="16" r="16" fill={circleFill} />
      <path
        d="M20.6 9H23.054L17.694 14.9302L24 23H19.063L15.196 18.1048L10.771 23H8.316L14.049 16.6566L8 9H13.063L16.558 13.4732L20.6 9ZM19.74 21.5788H21.1L12.323 10.3469H10.865L19.74 21.5788Z"
        fill={pathFill}
      />
    </svg>
  );
};
// HumburgerMenu Icon in navbar
export const HumburgerMenu = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="12" fill="#E97219" />
      <path
        d="M18 7.71429C18 8.10952 17.665 8.42857 17.25 8.42857H6.75C6.335 8.42857 6 8.10952 6 7.71429C6 7.31905 6.335 7 6.75 7H17.25C17.665 7 18 7.31905 18 7.71429ZM17.25 15.5714H6.75C6.335 15.5714 6 15.8905 6 16.2857C6 16.681 6.335 17 6.75 17H17.25C17.665 17 18 16.681 18 16.2857C18 15.8905 17.665 15.5714 17.25 15.5714ZM13.25 11.2857H6.75C6.335 11.2857 6 11.6048 6 12C6 12.3952 6.335 12.7143 6.75 12.7143H13.25C13.665 12.7143 14 12.3952 14 12C14 11.6048 13.665 11.2857 13.25 11.2857Z"
        fill="white"
      />
    </svg>
  );
};
// cross Icon navbar
export const CrossIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="12" fill="#E97219" />
      <g clip-path="url(#clip0_2015_16780)">
        <rect
          x="7.99023"
          y="7"
          width="12"
          height="1.4"
          rx="0.7"
          transform="rotate(45 7.99023 7)"
          fill="white"
        />
      </g>
      <rect
        x="7"
        y="15.4854"
        width="12"
        height="1.4"
        rx="0.7"
        transform="rotate(-45 7 15.4854)"
        fill="white"
      />
      <defs>
        <clipPath id="clip0_2015_16780">
          <rect
            width="10"
            height="10"
            fill="white"
            transform="translate(7 7)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
// swiper left icon
export const SwiperLeftIcon = () => {
  return (
    <svg
      className="transition_03"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" stroke="#AE3E13" />
      <path
        className="transition_03"
        d="M18 12L13.8259 15.7567C13.3845 16.1539 13.3845 16.8461 13.8259 17.2433L18 21"
        stroke="#AE3E13"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
// swiper right icon
export const SwiperRightIcon = () => {
  return (
    <svg
      className="transition_03"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="-0.5"
        y="0.5"
        width="31"
        height="31"
        rx="15.5"
        transform="matrix(-1 0 0 1 31 0)"
        stroke="#AE3E13"
      />
      <path
        className="transition_03"
        d="M14 12L18.1741 15.7567C18.6155 16.1539 18.6155 16.8461 18.1741 17.2433L14 21"
        stroke="#AE3E13"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

// Dropdown arrow icon
export const DropdownArrowIcon = ({ className }) => {
  return (
    <svg
      className={className}
      width="12"
      height="8"
      viewBox="0 0 12 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 1.5L6 6.5L11 1.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DonationIcon = ({ circleFill, pathFill }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16" cy="16" r="16" fill={circleFill} />
      <path
        d="M10.8 17.3V15.7h2.8c1.2 0.2 2.4 0.8 3.6 1.6h2.2c1 0.1 1.5 1 0.5 1.7-0.8 0.6-1.8 0.5-2.8 0.4-0.7-0.1-0.7 0.9 0 0.9 0.2 0 0.5-0.1 0.8-0.1 1.3-0.1 2.4-0.3 3-1.3l0.3-0.8l3.2-1.6c1.6-0.5 2.8 1.2 1.5 2.3-2.3 1.7-4.7 3.1-7.1 4.2-1.8 1.1-3.6 1-5.3 0L10.8 17.3zM16.8 8c0.6-0.7 1-1.2 2-1.4 1.8-0.2 3.3 1.7 2.5 3.4-0.2 0.5-0.8 1.1-1.3 1.7-0.7 0.7-1.3 1.3-1.8 1.8l-1.3 1.3l-1.1-1c-1.2-1.3-3.5-2.8-3.6-4.9-0.1-1.3 1-2.2 2.3-2.2 0.8 0 1.3 0.6 1.7 1.2zM5 14.8h4.2v7.5H5V14.8z"
        fill={pathFill}
      />
    </svg>
  );
};
